export default function getIsCurrentGroupChapter(state: any) {
  return state.getIn(['currentGroup', 'data', 'type']) === 2;
}
